<div class="modal-body width-500">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('Header')}}
    </span>
    <div class="content grid-cols-2">
      <p [innerHTML]="confirmationText">
        <!--Fallback Text-->
        Möchten Sie den Status von <strong>{{enumSvc.getEnumerationText(data.enmName, data.currentEnmIdent)}}</strong> zu <strong>{{enumSvc.getEnumerationText(data.enmName, data.newEnmIdent)}}</strong> ändern?
      </p>
      <exg-textarea class="span-2"
                    caption="{{getRessource('ChangeComment')}}"
                    name="comment"
                    [maxlength]="2048"
                    [(ngModel)]="this.uiModel.comment">
      </exg-textarea>
    </div>
    <div class="spawn-modal-actions typo-small">
      <button (click)="save()" class="md-btn">
        {{btnText}}
      </button>
      <button (click)="cancel()" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
    </div>
  </div>
</div>
